import React from 'react';
import { INCIDENT_EPISODE_TYPE } from '../incident/incident.model';
/* 
Obsolete modules
export const MODULE_PANDEMIC = 1;
export const MODULE_VACCINATION = 7;
export const MODULE_TEST = 8;
export const MODULE_SCREEN = 10;
export const MODULE_ATTENDANCE = 5; // hidden, not used
export const MODULE_REPORTS = 4;
export const MODULE_INJURY_REPORT = 6;
export const MODULE_INCIDENT_REPORTING = 9;
еxport const MODULE_TELEHEALTH = 11;
export const MODULE_IMMUNIZATION = 16;
export const MODULE_LIFEWORKS = 13;
*/

export const MODULE_PERMISSION = {
    NONE: 0,
    VIEW: 1,
    EDIT: 2,
};

export const MODULE_INCIDENT = 20;
export const MODULE_WC_INCIDENT = 12;
export const MODULE_AUTO_INCIDENT = 17;
export const MODULE_LIABILITY_INCIDENT = 18;
export const MODULE_PROPERTY_INCIDENT = 19;
export const MODULE_NON_REVENUE_INCIDENTS = 21; // MODULE_STUDENT_INCIDENT
export const MODULE_ACCESS_ASSISTANCE_INCIDENT = 22;
export const MODULE_HP_LIABILITY_INCIDENT = 23;
export const MODULE_WORKPLACE_VIOLENCE_INCIDENT = 24;
export const MODULE_MESSAGE_CENTER_INCIDENT = 25;
export const MODULE_LIN_DIRECT_INCIDENT = 26;
export const MODULE_HEALTHCARE_INCIDENT = 27;
export const MODULE_CRISIS_INCIDENT = 28;
export const MODULE_DRUG_TESTING_INCIDENT = 29;
export const MODULE_THEFT_AWARENESS_INCIDENT = 30;

export const MODULE_ALERTS = 2;
export const MODULE_BENEFITS = 3;
export const MODULE_INTEGRITY_LINE = 14;
export const MODULE_WECONNECT = 15;

const Alerts = React.lazy(() => import('routes/administration/routes/alerts'));
const IntegrityLine = React.lazy(() => import('routes/administration/routes/integrityLine'));
const Incidents = React.lazy(() => import('routes/administration/routes/incidents'));
const IncidentGenericList =  React.lazy(() => import('routes/administration/routes/incidents/list/listGeneric'));

const IncidentsWC = React.lazy(() => import('routes/administration/routes/incidents/list/listWc'));
const IncidentsWorkplaceViolence = React.lazy(() => import('routes/administration/routes/incidents/list/listWorkplaceViolence'));
const IncidentsLinDirect = React.lazy(() => import('routes/administration/routes/incidents/list/listLinDirect'));
const IncidentsHealthcare = React.lazy(() => import('routes/administration/routes/incidents/list/listHealthcare'));
const IncidentsCrisis = React.lazy(() => import('routes/administration/routes/incidents/list/listCrisis'));

/* VisibleOn
locationMenu: location edit, submenu,
adminPermissions: edit admin, assign module permission,
adminListPermissions: admin list, modules columns
locationList: location list, modules column + icons,
noPermissions: hide module if no permissions assigned
*/

export const ModulesConfig = {
    incident: {
        module: 'incident',
        id: MODULE_INCIDENT,
        title: 'Incidents',
        desc: 'Incidents Module',
        route: '/incidents',
        menu: 'incident',
        component: Incidents,
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            locationMenu: true,
            adminPermissions: true,
        },
    },
    incidentWc: {
        module: 'incidentWc',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.wc,
        id: MODULE_WC_INCIDENT,
        component: IncidentsWC,
        title: 'Workers` Compensation',
        desc: 'WC Incidents Module',
        route: '/I',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            ladminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentAuto: {
        module: 'incidentAuto',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.auto,
        id: MODULE_AUTO_INCIDENT,
        component: IncidentGenericList,
        title: 'Auto',
        desc: 'Auto Incidents Module',
        route: '/A',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentLiability: {
        module: 'incidentLiability',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.liability,
        id: MODULE_LIABILITY_INCIDENT,
        component: IncidentGenericList,
        title: 'Liability',
        desc: 'Liability Incidents Module',
        route: '/L',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    /*  @COMMENT Should be hidden for DS portal users */
    incidentNonRevenue: {
        module: 'incidentNonRevenue',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.nonRevenue,
        id: MODULE_NON_REVENUE_INCIDENTS,
        component: IncidentGenericList,
        title: 'Non Revenue',
        desc: 'NonRevenue Incidents Module',
        route: '/NR',
        roles: ['SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            locationMenu: false,
            adminPermissions: false,
            adminListPermissions: false,
            locationList: false,
        },
    },
    incidentProperty: {
        module: 'incidentProperty',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.property,
        id: MODULE_PROPERTY_INCIDENT,
        component: IncidentGenericList,
        title: 'Property',
        desc: 'Property Incidents Module',
        route: '/P',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentAccessAssistance: {
        module: 'incidentAccessAssistance',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.accessAssistance,
        id: MODULE_ACCESS_ASSISTANCE_INCIDENT,
        component: IncidentGenericList,
        title: 'Access Assistance',
        desc: 'Access Assistance Incidents Module',
        route: '/AA',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentHighProfileLiability: {
        module: 'incidentHighProfileLiability',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.highProfileLiability,
        id: MODULE_HP_LIABILITY_INCIDENT,
        component: IncidentGenericList,
        title: 'High Profile Liability',
        desc: 'High Profile Liability Incidents Module',
        route: '/HP',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentWorkplaceViolence: {
        module: 'incidentWorkplaceViolence',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.workplaceViolence,
        id: MODULE_WORKPLACE_VIOLENCE_INCIDENT,
        component: IncidentsWorkplaceViolence,
        title: 'Workplace Violence',
        desc: 'Workplace Violence Incidents Module',
        route: '/WV',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentMessageCenter: {
        module: 'incidentMessageCenter',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.messageCenter,
        id: MODULE_MESSAGE_CENTER_INCIDENT,
        component: IncidentGenericList,
        title: 'Message Center',
        desc: 'Message Center Module',
        route: '/MC',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    /*  @COMMENT Should be hidden for admins with no permissions */
    incidentLinDirect: {
        module: 'incidentLinDirect',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.linDirect,
        id: MODULE_LIN_DIRECT_INCIDENT,
        component: IncidentsLinDirect,
        title: 'Lin Direct',
        desc: 'Lin Direct',
        route: '/D',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: false,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentHealthcare: {
        module: 'incidentHealthcare',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.healthcare,
        id: MODULE_HEALTHCARE_INCIDENT,
        component: IncidentsHealthcare,
        title: 'Healthcare',
        desc: 'Healthcare',
        route: '/HC',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentCrisis: {
        module: 'incidentCrisis',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.crisis,
        id: MODULE_CRISIS_INCIDENT,
        component: IncidentsCrisis,
        title: 'Crisis',
        desc: 'Crisis',
        route: '/CR',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentDrugTesting: {
        module: 'incidentDrugTesting',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.drugTesting,
        id: MODULE_DRUG_TESTING_INCIDENT,
        component: IncidentGenericList,
        title: 'Drug Testing',
        desc: 'Drug Testing',
        route: '/DT',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    incidentTheftAwareness: {
        module: 'incidentTheftAwareness',
        parentId: MODULE_INCIDENT,
        episodeTypeId: INCIDENT_EPISODE_TYPE.theftAwareness,
        id: MODULE_THEFT_AWARENESS_INCIDENT,
        component: IncidentGenericList,
        title: 'Theft Awareness',
        desc: 'Theft Awareness',
        route: '/T',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    alerts: {
        module: 'alerts',
        id: MODULE_ALERTS,
        component: Alerts,
        title: 'Alerts & Newsfeed',
        desc: 'Alerts/Newsfeed Module',
        route: '/alerts',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            locationMenu: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    benefits: {
        module: 'benefits',
        id: MODULE_BENEFITS,
        title: 'Benefits',
        desc: 'Benefits Module',
        route: '/benefits',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            locationMenu: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    integrityLine: {
        module: 'integrityLine',
        id: MODULE_INTEGRITY_LINE,
        title: 'Integrity Line',
        desc: 'Integrity Line module',
        route: '/integrityLine',
        component: IntegrityLine,
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {
            noPermissions: true,
            locationMenu: true,
            adminPermissions: true,
            adminListPermissions: true,
            locationList: true,
        },
    },
    WEconnect: {
        module: 'WEconnect',
        id: MODULE_WECONNECT,
        title: 'WEconnect',
        desc: 'WEconnect module',
        route: '/WEconnect',
        roles: ['ADMIN', 'SYS_ADMIN'],
        visibleOn: {},
    },
};

export const IncidentModuleRoute = ModulesConfig.incident.route;

export const getIncidentSubmodules = $user => Object.values(ModulesConfig)
    .filter(item => item.parentId === MODULE_INCIDENT)
    .filter(item => (item.roles || ['ADMIN', 'SYS_ADMIN']).includes($user.role))
    .filter((item) => {
        const allowed = !!$user.permissions[item.id];
        return allowed || (item.visibleOn.noPermissions && !allowed);
    });
    
export const hasEditPermission = (user, module) => 
        user.permissions[ModulesConfig[module]?.id] === MODULE_PERMISSION.EDIT;
